import React from 'react'

let CardTitle = ({text}) => <div className='card-title'>{text}</div>

export default CardTitle